import { render, staticRenderFns } from "./RegiaoCepForm.vue?vue&type=template&id=afd22de4"
import script from "./RegiaoCepForm.vue?vue&type=script&lang=js"
export * from "./RegiaoCepForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports